module.exports = __webpack_public_path__ + "static/media/paper-1.3a8f4b2c.png";